import { Toggle } from "@atoms/index"

export default function UseCompanyTimezoneToggler() {
    return <Toggle isDisabled={true} checked={true} size="md" isControlled={false} />
}
